/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Small_Extra_Donkey_CoaxInputs */

const fr_small_extra_donkey_coax = /** @type {(inputs: Small_Extra_Donkey_CoaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déconnexion`)
};

/**

* @param {Small_Extra_Donkey_CoaxInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const small_extra_donkey_coax = /** @type {((inputs?: Small_Extra_Donkey_CoaxInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Small_Extra_Donkey_CoaxInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_small_extra_donkey_coax(inputs)
});